// Every release note the dashboard shows, one list per app, newest first.
//
// ADDING A RELEASE. Three things, in the same pull request as the change itself:
//
//   1. A file `<app>/v<x.y.z>.js` holding version, date (the date it reaches PROD, ISO
//      YYYY-MM-DD), tags, and the body.
//   2. Its import and its entry at the TOP of that app's list below.
//   3. Nothing else. There is no package.json version to keep in sync: the top entry of the list
//      IS the app's current version, so the two cannot drift apart.
//
// MINOR (1.1.0) for something MW would notice as new or different, PATCH (1.0.1) for a fix. MAJOR
// is reserved; ask before spending it.
//
// Write the body FOR MW: plain Danish with real æ, ø and å, what changed for them, no issue
// numbers, no branch names, no internal vocabulary. Keep the system's own terms in ENGLISH, exactly
// as MW see them on screen: Matter, Work Type, Billing Type, Non Billable, timelog, employee,
// Frontend (Kalenderen), Backend. Patrick's rule 2026-09-18, and the reason the Fix tag is English
// too. A change nobody at MW can see (a health check,
// a base image, an internal read path) gets no note at all.
//
// The bodies are plain JS template literals rather than .md files on purpose. This client is
// Create React App (react-scripts 5.0.1, no craco), so importing a .md file yields a URL rather
// than its text, and the service tool's `import.meta.glob(..., '?raw')` is Vite only. A .js module
// needs no loader config and behaves identically in the browser bundle and in the Jest run.

import calendar_1_2_2 from './calendar/v1.2.2';
import calendar_1_2_1 from './calendar/v1.2.1';
import calendar_1_2_0 from './calendar/v1.2.0';
import calendar_1_1_0 from './calendar/v1.1.0';
import calendar_1_0_3 from './calendar/v1.0.3';
import calendar_1_0_2 from './calendar/v1.0.2';
import calendar_1_0_1 from './calendar/v1.0.1';
import calendar_1_0_0 from './calendar/v1.0.0';

import dashboard_1_3_0 from './dashboard/v1.3.0';
import dashboard_1_2_0 from './dashboard/v1.2.0';
import dashboard_1_1_0 from './dashboard/v1.1.0';
import dashboard_1_0_0 from './dashboard/v1.0.0';

// The tags a note may carry. A closed set, enforced by releaseNotesContent.test.js, so a typo or a
// fourth improvised tag cannot reach MW.
export const RELEASE_TAGS = ['Nyt', 'Forbedret', 'Fix'];

// The two apps, in the order their tabs appear. `key` is what the ?app= deep link carries.
export const RELEASE_APPS = [
    {
        key: 'calendar',
        label: 'Kalender',
        notes: [
            calendar_1_2_2,
            calendar_1_2_1,
            calendar_1_2_0,
            calendar_1_1_0,
            calendar_1_0_3,
            calendar_1_0_2,
            calendar_1_0_1,
            calendar_1_0_0,
        ],
    },
    {
        key: 'dashboard',
        label: 'Admin dashboard',
        notes: [
            dashboard_1_3_0,
            dashboard_1_2_0,
            dashboard_1_1_0,
            dashboard_1_0_0,
        ],
    },
];

export function findApp(key) {
    return RELEASE_APPS.find(app => app.key === key) || RELEASE_APPS[0];
}
